// Generated by tools/icons/generate.mjs. Edit the SVG source and manifest instead.
import * as React from "react"
const CheckMarkIcon = /* @__PURE__ */ React.forwardRef<SVGSVGElement, React.ComponentProps<"svg">>((props, ref) => {
  return (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
      <path
        d="M19.5367 6.97609C19.826 7.27249 19.8203 7.74732 19.5239 8.03667L10.6477 16.7019C10.1684 17.1698 9.40546 17.1767 8.91773 16.7176L4.48595 12.5461C4.18434 12.2622 4.16998 11.7876 4.45388 11.4859C4.73778 11.1843 5.21244 11.17 5.51405 11.4539L9.77132 15.4611L18.4761 6.96333C18.7725 6.67398 19.2473 6.67969 19.5367 6.97609Z"
        fill="currentColor"
      />
    </svg>
  )
})
CheckMarkIcon.displayName = "CheckMarkIcon"
export { CheckMarkIcon }
